import Crud from "../crud"
import ApiService from "@/utils/api.service"
import { GET_LOGO, SET_LOGO } from "@/store/actions/client"
import Vue from "vue"
var crud = new Crud("clients")

const state = {
  client: {},
  ...crud.state,
}
const getters = {
  ...crud.getters,
}
const actions = {
  [GET_LOGO]: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      ApiService.get(`clients/home`, params)
        .then((resp) => {
          commit(SET_LOGO, resp.data)
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  ...crud.actions,
}
const mutations = {
  [SET_LOGO](state, data) {
    Vue.set(state.client, "logo", data.logo)
  },
  ...crud.mutations,
}

export default {
  state,
  getters,
  actions,
  mutations,
}
